import { FC } from "react";
import { Deployment } from "../../../lib/src/api/partner/models/Deployment";
import { DeploymentStatusLabel } from "../../../lib/src/components/DeploymentStatusLabel";
import { Input } from "@hostingbv/lib/src/components/form/Input";


export const DeploymentDetailsModal: FC<{ deployment: Deployment }> = (props) => {
  return <>
    <table className={"w-full mb-4"}>
      <tbody>
        <tr>
          <th className={"text-left pr-4"}>Name</th>
          <td className={"w-full"}>{props.deployment.entityName}</td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Type</th>
          <td className={"w-full"}>{props.deployment.type}</td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Status</th>
          <td className={"w-full"}><DeploymentStatusLabel status={props.deployment.status} /></td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Started</th>
          <td
            className={"w-full"}>{props.deployment.started?.toLocaleDateString('nl')} {props.deployment.started?.toLocaleTimeString()}</td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Finished</th>
          <td
            className={"w-full"}>{props.deployment.finished?.toLocaleDateString('nl')} {props.deployment.finished?.toLocaleTimeString()}</td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Initiator</th>
          <td
            className={"w-full"}>{props.deployment.initiatedName}</td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Input</th>
          <td className={"w-full"}>
            <Input type={'textarea'} readonly label={'Input'} value={JSON.stringify(filterInput(props.deployment.input), undefined, 2)} onChange={() => { }} />
          </td>
        </tr>
        <tr>
          <th className={"text-left pr-4"}>Output</th>
          <td className={"w-full"}>
            <Input type={'textarea'} readonly label={'Output'} value={JSON.stringify(filterOutput(props.deployment.output), undefined, 2)} onChange={() => { }} />
          </td>
        </tr>
      </tbody>
    </table>
  </>
}
const inputKeyWhitelist: string[] = [
  'domain',
  'add',
  'edit',
  'delete',
  'php_handler',
  'email_address',
  'email',
  'target',

  // WindhostingSite
  'phpVersion',
  'certificate',
  'php_version',
  'php_pool_config',
  'webserver_config',
]

function filterInput(input: Deployment['input']): object {
  return Object.fromEntries(Object.entries(input)
    .filter(([k]) => inputKeyWhitelist.includes(k)))
}

const outputKeyWhitelist: string[] = [
  'user_error',
  'request_id'
]

function filterOutput(output: Deployment['output']): object {
  if (output === null) {
    return {}
  }
  return Object.fromEntries(Object.entries(output)
    .filter(([k]) => outputKeyWhitelist.includes(k)))
}
